import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { ReactComponent as CheckmarkCircle } from '../../../../assets/images/CheckmarkCircle.svg';
import { ReactComponent as CrossOutlined } from '../../../../assets/images/cross-outlined.svg';
import { ReactComponent as CrossIcon } from '../../../../assets/images/cross-secondary.svg';

import styles from './ImportHistory.module.scss';

const ImportHistoryDetails = ({ data, onDelete }) => {
  const { t } = useTranslation('common');
  return (
    <table className={styles.imprtHistoryTable}>
      <thead>
        <tr>
          <td className={styles.tableHeaders}>{t('labels.name')}</td>
          <td className={styles.tableHeaders}>{t('labels.date')}</td>
          <td className={styles.tableHeaders}>{t('labels.result')}</td>
        </tr>
      </thead>
      <tbody>
        {data.map(({ id, source, file_name, total_records, valid_records, created_at, status }) => (
          <tr key={id} className={styles.container}>
            <td>
              <div className={styles.sourceName}>{source}</div>
              <div className={styles.sourceFile}>{file_name}</div>
            </td>
            <td className={styles.date}>{moment.unix(created_at).format('hh:mm A MM/DD/YYYY')}</td>
            <td className={styles.checkContainer}>
              <div className={styles.resultCont}>
                {status === 'processing' ? (
                  <span className={styles.processingText}>{t('csvImport.importProcessing')}</span>
                ) : (
                  <>
                    {valid_records === 0 ? (
                      <span className={styles.svgContainer}>
                        <CrossOutlined />
                      </span>
                    ) : (
                      <CheckmarkCircle />
                    )}
                    <span className={styles.secondaryText}>
                      {t('csvImport.recordsCreated', { valid: valid_records, total: total_records })}
                    </span>
                  </>
                )}
              </div>
            </td>
            <td>
              <button onClick={() => onDelete(id)} type="button" className={styles.crossIcon}>
                <CrossIcon />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ImportHistoryDetails;
